import Vue from 'vue';

const filters = {
  toLocaleDateString(date) {
    if (!date) { return ''; }
    return new Intl.DateTimeFormat('de-ch', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(date));
  },
  toLocaleDateTimeString(date) {
    if (!date) { return ''; }
    return new Intl.DateTimeFormat('de-ch', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(date));
  },
};

Object.entries(filters).forEach(([name, filter]) => {
  Vue.filter(name, filter);
});
